import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import { useAppGameDetailsSelector } from "src/_common/hooks/selectors/eventSelector";
import { APPLICATION_GLOBAL_SLUG, removeEmptyObjectKey, SOCKET_CHANNEL } from "src/_config";

interface RPRodeoTvImageProps {
  globalTvData: Record<string, unknown> | null;
  socketChannel: string | null;
  setGlobalTvData: (data: Record<string, unknown> | null) => void;
  setSocketChannel: (channel: string | null) => void;
  rodeoEventId: string | null;
}

export function RodeoTvImageComponent({
  globalTvData,
  socketChannel,
  setGlobalTvData,
  setSocketChannel,
  rodeoEventId,
}: RPRodeoTvImageProps) {
  const eventApi = useEventApi();
  // const tvImageSelector = useAppTvImageSelector()
  const { gameId } = useParams<{ gameId?: string }>();
  const [isInitialLoad, setIsInitialLoad] = useState<boolean>(false);
  const [isShowingAdsPromotion, setIsShowingAdsPromotion] = useState<boolean>(false);
  const [addPromotionImage, setAddPromotionImage] = useState<string | null>(null);
  const [adPromotionText, setAdPromotionText] = useState<string | null>(null);
  const gameDetails = useAppGameDetailsSelector() as { logo?: { original?: string } } | null;
  const [tvLeaderboardList, setTvLeaderboardList] = useState<Array<{
    id?: string | number;
    name?: string;
    value_to_show?: number | string;
    avatar?: string;
  }> | null>(null);
  const [tvImageSelector, setTvImageSelector] = useState<{
    limit?: number;
    rodeo_event_dtls?: { title?: string };
    performance_dtls?: { title?: string };
    event_dtls?: { rodeo_pick_event?: { title?: string }; sponsor?: { title?: string } };
  } | null>(null);
  const tvData = (globalTvData || {}) as {
    rodeo_event_id?: string | number;
    performance_id?: string | number;
    event_id?: string | number;
    type?: string;
    image?: string;
    text?: string;
  };

  const getTvImageDetails = (screen1: string, type: string | null, _globalDataType?: string) => {
    const params: Record<string, unknown> = {
      screen1,
      type,
    };

    eventApi.callTvImageDetails(
      removeEmptyObjectKey(params),
      (_message: string, resp: unknown) => {
        console.log("============ ", resp, globalTvData, typeof resp);
        setTvImageSelector(resp as typeof tvImageSelector);
        if (resp) {
          const users = (resp as { users?: { data?: Array<Record<string, unknown>> } })?.users?.data;
          const mappedUsers = (users || []).map((p) => {
            const data = p as {
              id?: string | number;
              display_name?: string;
              first_name?: string;
              last_name?: string;
              avatar?: { id?: number; original?: string } | Record<string, unknown>;
              percentage?: number;
            };
            const name = data.display_name || `${data.first_name || ""} ${data.last_name || ""}`.trim();
            const avatar =
              data.avatar && "id" in data.avatar && (data.avatar as { id?: number })?.id != 0
                ? (data.avatar as { original?: string })?.original
                : "/images/no-image.png";
            return {
              id: data.id,
              name,
              avatar,
              value_to_show: data.percentage ?? 0,
            };
          });
          console.log(">>>>>>>>>>>>>>>>>>> ", mappedUsers);
          setTvLeaderboardList(mappedUsers.length ? mappedUsers : null);
        }
      },
      (message: string) => {
        console.error(`Error at API Access => ${message}`);
      },
    );
    // }
  };

  const getGameDetails = () => {
    const params = {
      slug: APPLICATION_GLOBAL_SLUG,
    };
    eventApi.callGetGameDetails(
      params,
      (_message: string, _resp: unknown) => {
        // console.log({resp})
      },
      (_message: string) => {},
    );
  };

  const resetCssStyle = (type: string) => {
    const element = document.getElementById("rodeo_body");
    if (element) {
      if (["leaderboard", "ad"].includes(type)) {
        element.style.padding = "0 30px";
        element.style.paddingTop = "2.5em";
      } else {
        element.style.padding = "0px";
      }
    }
  };

  useEffect(() => {
    console.log({ globalTvData, rodeoEventId, tvData });
    const tvRodeoEventId = tvData.rodeo_event_id !== undefined ? String(tvData.rodeo_event_id) : undefined;
    if (globalTvData && socketChannel && tvRodeoEventId && tvRodeoEventId == rodeoEventId) {
      resetCssStyle("landing");

      switch (socketChannel) {
        case SOCKET_CHANNEL.TV_BOARD_IMAGE:
          if (tvData.type == "rodeo_event") {
            getTvImageDetails(String(tvData.rodeo_event_id ?? ""), "N");
            resetCssStyle("leaderboard");
            // resetCssStyle()
            setIsShowingAdsPromotion(false);
            setIsInitialLoad(false);
          } else if (tvData.type == "rodeo_event_overall") {
            getTvImageDetails(String(tvData.rodeo_event_id ?? ""), "OE");
            resetCssStyle("leaderboard");
            // resetCssStyle()
            setIsShowingAdsPromotion(false);
            setIsInitialLoad(false);
          } else if (tvData.type == "performance") {
            getTvImageDetails(`${tvData.rodeo_event_id}||${tvData.performance_id}`, "N");
            resetCssStyle("leaderboard");
            // resetCssStyle()
            setIsShowingAdsPromotion(false);
            setIsInitialLoad(false);
          } else if (tvData.type == "performance_overall") {
            getTvImageDetails(`${tvData.rodeo_event_id}||${tvData.performance_id}`, "OE");
            resetCssStyle("leaderboard");
            // resetCssStyle()
            setIsShowingAdsPromotion(false);
            setIsInitialLoad(false);
          } else if (tvData.type == "event") {
            getTvImageDetails(`${tvData.rodeo_event_id}||${tvData.performance_id}||${tvData.event_id}`, "N");
            resetCssStyle("leaderboard");
            // resetCssStyle()
            setIsShowingAdsPromotion(false);
            setIsInitialLoad(false);
          } else {
            resetCssStyle("landing");
            if (gameId) {
              getTvImageDetails(gameId, null);
            }
            setIsInitialLoad(true);
          }

          break;

        case SOCKET_CHANNEL.ADV_PROMOTION:
          resetCssStyle("ad");
          setIsInitialLoad(false);

          setIsShowingAdsPromotion(true);
          setAddPromotionImage(tvData.image ?? null);
          setAdPromotionText(tvData.text ?? null);
          // default_timeout available but unused in this view
          break;
      }
      setGlobalTvData(null);
      setSocketChannel(null);
    }
  }, [globalTvData, socketChannel]);

  useEffect(() => {
    if (gameId) {
      getTvImageDetails(gameId, null);
    }
    getGameDetails();
    setIsInitialLoad(true);
    const element = document.getElementById("rodeo_body");
    if (element) {
      element.style.paddingTop = "0px";
      element.style.marginBottom = "0px";
      element.style.backgroundColor = "#fff";
    }
  }, []);

  return (
    <React.Fragment>
      {isInitialLoad ? (
        <div
          className="main-bg"
          style={{
            backgroundImage: `url("${"/images/tv/tv-screen-blank1.jpg"}")`,
            position: "fixed",
            width: "100%",
            height: "100%",
            backgroundSize: "100% 100%",
            backgroundRepeat: "no-repeat",
          }}
        ></div>
      ) : (
        <>
          <div
            className="main-bg"
            style={{
              backgroundColor: "#000",
              position: "fixed",
              width: "100%",
              height: "100%",
              left: 0,
              top: 0,
              zIndex: -1,
              overflowX: "hidden",
              margin: 0,
            }}
          ></div>
          <section className="container" style={{ maxWidth: "100%" }}>
            <div className="logobar ">
              <div className="border-div" />
              <div className="border-div2" />
              <div className="logo_left_txt">
                {isShowingAdsPromotion && adPromotionText
                  ? adPromotionText
                  : `${
                      (tvImageSelector?.rodeo_event_dtls as { title?: string } | undefined)?.title
                        ? (tvImageSelector?.rodeo_event_dtls as { title?: string } | undefined)?.title
                        : "--"
                    }${
                      (tvImageSelector?.performance_dtls as { title?: string } | undefined)?.title
                        ? " :: " + (tvImageSelector?.performance_dtls as { title?: string } | undefined)?.title
                        : ""
                    }${
                      (tvImageSelector?.event_dtls as { rodeo_pick_event?: { title?: string } } | undefined)
                        ?.rodeo_pick_event
                        ? " :: " +
                          ((tvImageSelector?.event_dtls as { rodeo_pick_event?: { title?: string } } | undefined)
                            ?.rodeo_pick_event?.title || "")
                        : ""
                    }`}
              </div>
              <div className="logo_image">
                <img src={gameDetails?.logo?.original} className="img-responsive" />
              </div>
            </div>

            <div className="heading_text">
              {(tvImageSelector?.event_dtls as { sponsor?: { title?: string } } | undefined)?.sponsor
                ? `SPONSORED BY ${(tvImageSelector?.event_dtls as { sponsor?: { title?: string } } | undefined)?.sponsor
                    ?.title || ""}`
                : null}
            </div>
            <div className="clearfix">
              {!isShowingAdsPromotion ? (
                <ul className="tv-list">
                  {tvLeaderboardList && tvLeaderboardList.length ? (
                    tvLeaderboardList
                      ?.slice(0, tvImageSelector && tvImageSelector.limit ? tvImageSelector.limit : 10)
                      .map((item) => (
                        <li key={String(item.id ?? "")}>
                          <div className="left_sec">
                            <div className="border-div"></div>
                            <div className="curve-bg">
                              <div className="left_sec_l">
                                {/* {item.avatar ? (
                                    <span className="event-img tv-avatar">
                                      <img src={item.avatar} />
                                    </span>
                                  ) : null} */}
                                <div>{item.name || ""}</div>
                              </div>
                              {/* <div className="left_sec_r">{removeTrailingZero(item.vote)} %</div> */}
                              <div className="left_sec_r">{item.value_to_show ?? ""}</div>
                            </div>
                          </div>
                        </li>
                      ))
                  ) : (
                    <div className="text-center" style={{ color: "#fff" }}>
                      <p> No Result publish yet!</p>
                    </div>
                  )}
                </ul>
              ) : (
                <div className="tv-ads-promotion">
                  <img src={addPromotionImage || undefined} alt="image" />
                </div>
              )}
            </div>
          </section>
        </>
      )}
    </React.Fragment>
  );
}
